$(function(){
  // $(".main-gallery").lightGallery({
  //   selector: ".gallery-item-image",
  //   download: false,
  //   loadYoutubeThumbnail: false,
  //   loadVimeoThumbnail: false,
  //   zoom: false,
  //   getCaptionFromTitleOrAlt:false,
  //   hash: false
  // });
  
});